import { createContext } from 'react';

import { useFetchImageByUrl } from '../../media/hooks/use-fetch-image-by-url';
import { useRevision } from '../hooks/use-revision';

export interface ModelDetailsContextInterface {
  useFetchImageByUrl: typeof useFetchImageByUrl;
  useRevision: typeof useRevision;
}

let context: React.Context<ModelDetailsContextInterface>;

export const getModelDetailsContext = () => {
  if (!context) {
    context = createContext({
      useFetchImageByUrl,
      useRevision,
    });
  }
  return context;
};
